module.exports = __webpack_public_path__ + "img/flags/NI.49391ad.png";